import { render, staticRenderFns } from "./NumberOption.vue?vue&type=template&id=0ca5c58e&"
import script from "./NumberOption.vue?vue&type=script&lang=js&"
export * from "./NumberOption.vue?vue&type=script&lang=js&"
import style0 from "./NumberOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports